export const GET_LOGIN_PHOTO = 'GET_LOGIN_PHOTO'
